module.exports = __webpack_public_path__ + "static/media/Banana Guy.509f6c0f.jpg";